import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "s20_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = { class: "s13 flex justify-content-right" }
const _hoisted_4 = { class: "s20 items-center gap-6 px-0 pb-6 collapse-content active" }
const _hoisted_5 = { class: "container-full-2 s20 mt-1 mb-5" }
const _hoisted_6 = {
  key: 0,
  class: "custom-filter-set-area"
}
const _hoisted_7 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_8 = { class: "form-field-floating reactive sm" }
const _hoisted_9 = { class: "form-field-floating sm" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-field-floating reactive sm" }
const _hoisted_12 = { class: "form-field-floating reactive sm" }
const _hoisted_13 = { class: "form-field-floating sm" }
const _hoisted_14 = { class: "table separator skin3 selection rounded" }
const _hoisted_15 = {
  class: "btn-circle",
  for: "check-list1"
}
const _hoisted_16 = ["checked"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  colspan: "10",
  class: "text-center py-5"
}
const _hoisted_19 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "selection-item" }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id", "value"]
const _hoisted_24 = { class: "font-semibold text-xl" }
const _hoisted_25 = { class: "font-semibold text-xl" }
const _hoisted_26 = { class: "flex-right" }

import { reactive, ref, onMounted, computed, inject, Ref, watch } from 'vue';
    import CustomButton from '@/components/CustomButton.vue';
    import { useConfirmationStore } from '@/stores/confirmation.store';
    import axios from 'axios';
    import { useToastStore } from '@/stores/toast.store';
    import { useRoute } from 'vue-router';
import moment from 'moment';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementCartes',
  emits: ['updated'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const route = useRoute();
    const confirmationStore = useConfirmationStore();
    const toastStore = useToastStore();
    const emits = __emit;
    const itemsList = ref([] as any[]);
    const filteredDatas = ref([] as Array<any>);
    const paginatedFilteredDatas = ref([] as Array<any>);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const filtersParams = reactive({
        name: '',
        num_lot: '',
        borneInf: null,
        borneSup: null,
        etatAssignation: ''
    });
    const startupInfos = reactive({
        lots: [] as any[],
    });
    const loading = ref(false);
    const loadingActions = ref(false);
    const collectivite = inject<Ref<any>>('collectivite');
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return paginatedFilteredDatas.value.length > 0 && selectedItems.value.filter(i => paginatedFilteredDatas.value.findIndex(p => p.id === i) !== -1).length === paginatedFilteredDatas.value.length;
    });
    const areAllItemsSelectedAssignable = computed(() => {
        return selectedItems.value.length > 0 && countItemsSelectedAssignable.value === selectedItems.value.length;
    });
    const countItemsSelectedAssignable = computed(() => {
        return itemsList.value.filter(i => selectedItems.value.includes(i.user_id) && !i.carte_id).length;
    });
    const showAdvancedFilters = ref(false);

    onMounted(() => {
        doListCarteItems();
    });

    watch(filtersParams, (oldValues, newValues) => {
        applyFilters();
        onPaginate(1);
    });

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = [...selectedItems.value.filter(s => itemsList.value.findIndex(p => p.id === s) === -1), ...itemsList.value.map(i => i.id)];
        } else {
            selectedItems.value = [];
        }
    }

    async function doListCarteItems(withoutLoading?: boolean) {
        try {
            if (!withoutLoading) { loading.value = true; }
            const httpResponse = await axios.get(`/backoffice/collectivites/${route.params.id}/get_collectivite_cartes_datas`);
            itemsList.value = httpResponse.data.data;
            startupInfos.lots = [...new Set(itemsList.value.filter(a => a.num_lot_carte).map(a => a.num_lot_carte))];
            applyFilters();
            onPaginate(1);
        } catch (error: any) {
            toastStore.error(error.message ?? "Une erreur est survenue lors de la requête au serveur");
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        pagination.total = filteredDatas.value.length;
        pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
        const start = (page - 1) * pagination.per_page;
        paginatedFilteredDatas.value =  filteredDatas.value.slice(start, start + pagination.per_page);
    }

    async function assignCartes(usersIds: any[]) {
        const confirmation = await confirmationStore.open('Assignation Carte', `Êtes-vous sûre de vouloir assigner ${usersIds.length > 1 ? `des cartes aux ${usersIds.length} membres sélectionnés` : `une carte au membre sélectionné`} ?`);
        if (!confirmation) return;

        try {
            loadingActions.value = true;
            await axios.post(`/backoffice/collectivites/${collectivite?.value.id}/assignation_cartes`, { ids: usersIds });
            selectedItems.value = [];
            doListCarteItems(true);
            toastStore.success("Assignation(s) effectuée(s)");
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loadingActions.value = false;
        }
    }

    function applyFilters() {
        let allDatas = itemsList.value;

        if (filtersParams.name) {
            allDatas = allDatas.filter(a => `${a.nom_user} ${a.prenom_user}`.toLowerCase().includes(filtersParams.name.toLowerCase()));
        }
        if (filtersParams.num_lot) {
            allDatas = allDatas.filter(a => a.num_lot_carte == filtersParams.num_lot);
        }
        if (filtersParams.borneInf) {
            const borneInf = moment(filtersParams.borneInf);
            if (borneInf.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_creation_carte = moment(a.created_at_carte);
                    return date_creation_carte.isValid() && date_creation_carte.isSameOrAfter(borneInf);
                })
            }
        }
        if (filtersParams.borneSup) {
            const borneSup = moment(filtersParams.borneSup);
            if (borneSup.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_creation_carte = moment(a.date_creation_carte);
                    return date_creation_carte.isValid() && date_creation_carte.isSameOrBefore(borneSup);
                })
            }
        }
        if (filtersParams.etatAssignation) {
            allDatas = allDatas.filter(a => filtersParams.etatAssignation == '1' && a.carte_id || filtersParams.etatAssignation == '2' && !a.carte_id);
        }
        
        filteredDatas.value = allDatas;
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "s7_mobile container-full-2" }, [
        _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/icons/icon-info-perso.svg",
            class: "size-l",
            alt: ""
          }),
          _createTextVNode(" Cartes ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (areAllItemsSelectedAssignable.value)
          ? (_openBlock(), _createBlock(CustomButton, {
              key: 0,
              type: "button",
              classesList: 'btn-ultra color2',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (assignCartes(selectedItems.value))),
              loading: loadingActions.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "Assigner carte (" + _toDisplayString(countItemsSelectedAssignable.value) + ")", 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(CustomButton, {
          type: "button",
          classesList: 'btn light',
          onClick: doListCarteItems
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: "/icons/icon-list.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Actualiser", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("button", {
          class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter",
          onClick: toggleAdvancedFilters
        }, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("img", {
            src: "/icons/icon-filter.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Options", -1)
        ]))])
      ]),
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (showAdvancedFilters.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtersParams.name) = $event)),
                      name: "name",
                      id: "name",
                      placeholder: "",
                      autocomplete: "off"
                    }, null, 512), [
                      [_vModelText, filtersParams.name]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("label", { for: "name" }, "Nom, prénoms", -1))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      name: "num_lot",
                      id: "num_lot",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtersParams.num_lot) = $event))
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Tous les lots", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.lots, (option, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: option,
                          key: 'filter_num_lot_' + index
                        }, "Lot " + _toDisplayString(option), 9, _hoisted_10))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, filtersParams.num_lot]
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("label", { for: "filters_sort" }, "Lot <=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-input",
                      name: "borneInf",
                      id: "borneInf",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtersParams.borneInf) = $event))
                    }, null, 512), [
                      [_vModelText, filtersParams.borneInf]
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("label", { for: "borneInf" }, "Date assignation <=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-input",
                      name: "borneSup",
                      id: "borneSup",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtersParams.borneSup) = $event))
                    }, null, 512), [
                      [_vModelText, filtersParams.borneSup]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("label", { for: "borneSup" }, "Date assignation >=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      name: "etat_assignation",
                      id: "etat_assignation",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtersParams.etatAssignation) = $event))
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("option", { value: "" }, "Toutes les cartes", -1),
                      _createElementVNode("option", { value: "1" }, "Carte assigné", -1),
                      _createElementVNode("option", { value: "2" }, "Aucune carte assigné", -1)
                    ]))], 512), [
                      [_vModelSelect, filtersParams.etatAssignation]
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("label", { for: "etat_assignation" }, [
                      _createTextVNode("Etat "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("table", _hoisted_14, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", _hoisted_15, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "check_all",
                    checked: areAllItemsSelected.value,
                    onChange: handleCheckAll
                  }, null, 40, _hoisted_16)
                ])
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("th", null, null, -1)),
              _cache[18] || (_cache[18] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Nom & Prénoms")
              ], -1)),
              _cache[19] || (_cache[19] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Numéro")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-down.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" N° de Lot")
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Banque")
              ], -1)),
              _cache[22] || (_cache[22] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Date de création")
              ], -1)),
              _cache[23] || (_cache[23] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Etat")
              ], -1)),
              _cache[24] || (_cache[24] = _createElementVNode("th", { class: "flex-right" }, "Actions", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                  _createElementVNode("td", _hoisted_18, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[25] || (_cache[25] = [
                          _createElementVNode("div", { class: "loader dark" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (paginatedFilteredDatas.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("td", {
                      colspan: "10",
                      class: "text-center py-5"
                    }, " Aucune membre trouvé ", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginatedFilteredDatas.value, (carte, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "text-grey-700 over-effect over-effect-scale",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("label", {
                          class: "btn-circle",
                          for: 'item_check_' + index
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "selectedItems[]",
                            id: 'item_check_' + index,
                            value: carte.user_id,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedItems).value = $event))
                          }, null, 8, _hoisted_23), [
                            [_vModelCheckbox, selectedItems.value]
                          ])
                        ], 8, _hoisted_22)
                      ]),
                      _cache[28] || (_cache[28] = _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "square-xl rounded-15",
                          style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
                        }, [
                          _createElementVNode("img", {
                            src: '/assets/users_avatar/600w/user.jpg',
                            width: "100%"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(carte.nom_user + ' ' + carte.prenom_user), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(carte.numero_masque_carte ?? '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(carte.num_lot_carte ?? '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(carte.nom_banque_carte ?? '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(carte.created_at_carte ?? '-'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["tag-state stroke", {'success': carte.etat_assignation, 'warning': !carte.etat_assignation}])
                        }, _toDisplayString(carte.etat_assignation ? 'Assigné' : 'Aucune carte assigné'), 3)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_26, [
                          (!carte.carte_id && _unref(collectivite)?.verrouille)
                            ? (_openBlock(), _createBlock(CustomButton, {
                                key: 0,
                                type: "button",
                                classesList: 'btn-ultra color2',
                                onClick: ($event: any) => (assignCartes([carte.user_id])),
                                loading: loadingActions.value
                              }, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createElementVNode("span", null, "Assigner carte", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick", "loading"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("   ")
                              ], 64))
                        ])
                      ])
                    ]))
                  }), 128))
          ])
        ]),
        _createVNode(_component_custom_pagination, {
          modelValue: queryParams.pageNumber,
          "onUpdate:modelValue": [
            _cache[7] || (_cache[7] = ($event: any) => ((queryParams.pageNumber) = $event)),
            onPaginate
          ],
          total: pagination.total,
          "per-page": pagination.per_page,
          last_page: pagination.last_page
        }, null, 8, ["modelValue", "total", "per-page", "last_page"])
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "clear-both h-25" }, null, -1))
    ])
  ]))
}
}

})